import { render, staticRenderFns } from "./verticalMenu.vue?vue&type=template&id=769107e2&scoped=true&"
import script from "./verticalMenu.vue?vue&type=script&lang=js&"
export * from "./verticalMenu.vue?vue&type=script&lang=js&"
import style0 from "./verticalMenu.vue?vue&type=style&index=0&id=769107e2&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769107e2",
  null
  
)

export default component.exports